import moment from "moment";
import { Moeda, Cia, Rota, BloqueioRodoviario } from "../../index";

export class TarifarioRodoviario {
    constructor() {
        this.Rotas = [];
        this.BloqueiosRodoviario = [];
    }

    Id: number = 0;
    MoedaId: number = 0;
    CiaRodoviariaId: number = 0;
    Nome: string;
    CiaRodoviaria: Cia;
    ValidadeDe: Date | moment.Moment;
    ValidadeAte: Date | moment.Moment;
    Moeda: Moeda;
    Rotas: Rota[];
    BloqueiosRodoviario: BloqueioRodoviario[];
    display_field: string = "";
}